module.exports = __webpack_public_path__ + "static/media/attachment.45904c2a.svg";